module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('default-layout', [(!_vm.my_submission) ? _c('div', {
    key: "loading",
    staticClass: "text-center mt-10"
  }, [_c('p', {
    staticClass: "mb-2.5"
  }, [_vm._v("Loading Submission")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1)]) : _c('div', [_c('div', {
    staticClass: "max-w-screen-2xl md:flex justify-between items-center pb-5"
  }, [_c('div', {
    staticClass: "flex flex-row items-center"
  }, [_c('div', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.getCurrentRT.title) + "\n        ")])]), _vm._v(" "), (_vm.getCurrentRT.enable_annonymous && !_vm.hasTeacherPermissionsInCourse) ? _c('identity-reveal', {
    staticClass: "mt-1 md:mt-0"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.windowWidth < 1024) ? _c('div', [_c('button', {
    staticClass: "mb-5 px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.openPromptInModal
    }
  }, [_vm._v("\n        Prompt\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "max-w-screen-2xl submission-response-body flex gap-5"
  }, [_c('div', {
    staticClass: "bg-white text-sm rounded border border-coolGray-200 p-5",
    class: _vm.toggle_prompt ? ['w-1/2'] : ['w-full']
  }, [_c('div', {
    staticClass: "w-full flex justify-between pb-2.5 border-b"
  }, [_c('div', {
    staticClass: "text-base font-semibold text-gray-500"
  }, [_vm._v("Submission")]), _vm._v(" "), (_vm.windowWidth >= 1024) ? _c('div', [_c('span', {
    staticClass: "text-gray-500 text-xs mr-2"
  }, [_vm._v("Discussion Prompt")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "toggle-button-class",
    attrs: {
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.toggle_prompt),
      callback: function($$v) {
        _vm.toggle_prompt = $$v
      },
      expression: "toggle_prompt"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.my_submission) ? _c('submission-form', {
    staticClass: "pt-5",
    attrs: {
      "submissionData": _vm.my_submission
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.toggle_prompt) ? _c('div', {
    staticClass: "w-1/2 bg-white text-sm rounded border border-coolGray-200 p-5"
  }, [_c('div', {
    staticClass: "w-full flex justify-between pb-2.5 border-b"
  }, [_c('div', {
    staticClass: "text-base font-semibold text-gray-500"
  }, [_vm._v("\n            Discussion Prompt\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("by " + _vm._s(_vm.author_name))])]), _vm._v(" "), _c('prompt', {
    staticClass: "pt-2.5 text-sm leading-7"
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.prompt_in_modal) ? _c('div', [_c('pl-dialog', {
    attrs: {
      "size": 'md',
      "title": 'Prompt'
    },
    on: {
      "close": function($event) {
        _vm.prompt_in_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "px-7 overflow-auto"
  }, [_c('prompt', {
    staticClass: "pt-4 text-sm leading-7"
  })], 1)])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1cd920c2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/submitResponsePage/submitResponsePage.vue
// module id = 1384
// module chunks = 61